/* eslint-disable vue/no-reserved-keys */
<template lang="html">
  <div class="content-item">
    <van-image
      round
      class="avater"
      v-if="!is_actual"
      src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/%E7%A5%9E%E7%A7%98%E5%A4%B4%E5%83%8F.png?x-oss-process=image/resize,m_fill,w_72,h_72"
    />
    <van-image
      width='36px'
      height='36px'
      fit="cover"
      round
      class="avater"
      @click="goDDconversation"
      v-else
      :src="`${user.real_avatar !== 'null' && user.real_avatar !== '' ? user.real_avatar : user.avatar}?x-oss-process=image/resize,m_fill,w_72,h_72`"
    >
      <template v-slot:error>{{ getErrorName }}</template>
    </van-image>
    <div class="content-item-body">
      <div @click="goRedirectDetails">
        <div class="content-item-body-header">
        <span class="content-item-body-header-h2" v-if="!is_actual">匿名用户</span>
        <span
          class="content-item-body-header-h2"
          v-else
          @click.stop="goDDconversation"
        >{{ user.fullname ? user.fullname : user.nickName }}</span>
      </div>
      <div class="desc">
        <span
          class="descInfo"
          v-html="content"
          :style="{ display: (expand ? 'block' : '-webkit-box') }"
          :ref="`${id}title`"
        ></span>
        <span
          v-if="showPand"
          @click.stop="expand = !expand"
          class="expand retract"
        >{{ expand ? '收起' : '展开' }}</span>
      </div>
      <div v-if="post_type === 'pdf'" class="content-item-pdf">
        <PDFthumbnail v-for="(item,index) of images" :key="index" :total=item />
      </div>
      <div
        ref="sortMenu"
        v-else-if="post_type === 'video'"
        :style="{'width':(screen_style === 'vertical' ? 140:220) +'px','height':(screen_style === 'vertical' ? 220:130) +'px'}"
        class="vid-wrappper">
        <img
          v-if="isShowIcon && this.$route.path.search('/dynamicTetail') === -1"
          src="../assets/images/dynamic/playBtn.png"
          class="play-img" />
        <video
          v-if="!isShowIcon && this.$route.path.search('/dynamicTetail') === -1 || this.$route.path.search('/dynamicTetail') !== -1"
          ref="video"
          muted
          @click.stop="cutSizeScreen"
          class="video"
          loop="loop"
          :width="screen_style === 'vertical' ? 140:220"
          :height="screen_style === 'vertical' ? 220:130"
          x5-playsinline=''
          playsinline='true'
          webkit-playsinline='true'
          x-webkit-airplay='true'
          x5-video-player-type=h5
          x5-video-player-fullscreen=''
          x5-video-orientation='portraint'
          :poster="images[0].url + '?x-oss-process=video/snapshot,t_1000,f_jpg,w_640,h_360'"
          >
          <source :src="images[0].url" type="video/mp4">
        </video>
        <img v-else class="video_img" @click.stop="cutSizeScreen" :width="screen_style === 'vertical' ? 140:220" :height="screen_style === 'vertical' ? 220:130" :src="`${images[0].url}?x-oss-process=video/snapshot,t_1000,m_fast`"/>
      </div>
      <div v-else class="content-item-imgs">
        <img
          v-if="getImages.length === 1"
          class="maxImg"
          @click.stop="changeModel(0)"
          v-lazy="`${getImages[0].url}?x-oss-process=image/resize,m_lfit,w_392,h_392`"
        />
        <img
          v-else
          v-for="(img, index) of getImages"
          :class="{ singal: getImages.length !== 4, square: Object.is(getImages.length, 4) }"
          @click.stop="changeModel(index)"
          :key="img.sort"
          v-lazy="`${img.url}?x-oss-process=image/resize,m_fill,w_184,h_184`"
        />
      </div>
      <div v-if="curriculum" class="curriculum" @click.stop="goCurriculumDetails(curriculum.id)">
        <img
          v-lazy="`${getHttpsImg(curriculum.cover)}?x-oss-process=image/resize,m_fill,w_240,h_134`"
        />
        <div>
          <label class="curriculum-title">{{ curriculum.title }}</label>
          <span class="studentCount">{{ curriculum.students }} 人学习过</span>
        </div>
      </div>
      <a v-if="link && Object.keys(link).length" @click.stop="goLink(link.url)" class="link-box">
        <img :src="link.imgUrl" />
        <span :style="{ 'webkit-line-clamp': IsURL(link.title) ? 1 : 3 }">{{ link.title }}</span>
      </a>
      <div class="tab-box" :class="commentCount > 0 ? 'message-division':''">
        <span class="tag-item" v-for="(tag) of tags" :key="tag.id">
          <span class="tag-desc" @click.stop="goFilterFind(tag)">#{{ tag.title }}</span>
        </span>
      </div>
      <div class="content-bottom">
        <div class="content-bottom-left">
          <h5>{{ getShowTime(crateTime) }}</h5>
          <span v-if="(users && users.id === user.id)" class="delete" @click.stop="deleteMessage">删除</span>
        </div>
        <div class="menus">
          <ThumbUpItem @click="thumbsUp" width="45px" v-bind="getThumbUp" />
          <ThumbUpItem @click="goDetails">
            <img src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/message-grey.svg" />
            <span>{{ commentCount ? commentCount : '评论' }}</span>
          </ThumbUpItem>
        </div>
      </div>
      </div>
      <!-- 评论外露功能 ing -->
      <div v-if="this.$route.path.search('/dynamicTetail') === -1">
        <REVIEWMESSAGE
          v-for="(item, index) in comment_list"
          @isShowMessage='isShowMessage'
          :index="index"
          :comment_list="comment_list"
          :key="item.nid"
          :isShow='isShow'
          :item="item"/>
      </div>
    </div>
    <ImgModel
      :imgs="modelSrc"
      :initialIndex="initialIndex"
      @click.native="changeModel"
      v-if="modelShow"
    />
  </div>
</template>
<script>
import { post, _delete } from '../utils/request'
import { get } from '../utils/token'
import { getBeforeTimeStr } from '../utils/date'
import ImgModel from '../components/ImgFile'
import ThumbUpItem from './thunmbUpItem'
import REVIEWMESSAGE from './reviewMessage.vue'
import { Toast } from 'vant'
import { isOverflow, IsURL, openSingleChat } from '../utils/utils'
import { messageInform } from '../api/api'
import PDFthumbnail from './PDFthumbnail.vue'
// import dd from 'DD'
export default {
  components: {
    ImgModel,
    ThumbUpItem,
    REVIEWMESSAGE,
    PDFthumbnail
  },
  props: {
    visible_range: {
      default: ''
    },
    frame_img_url: {
      default: ''
    },
    screen_style: {
      default: ''
    },
    post_type: {
      default: ''
    },
    videoPlay: {
      default: () => []
    },
    clientHeight: {
      default: 0
    },
    is_actual: {
      default: false
      // 获取是否匿名
    },
    id: {
      // type: Number,
      default: 0
    },
    user: {
      type: Object,
      default: () => {
        return {
          avatar: '',
          nickName: '',
          id: ''
        }
      }
    },
    crateTime: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    images: {
      type: Array,
      default: () => {
        return []
      }
    },
    commentCount: {
      type: Number,
      default: 0
    },
    upCount: {
      type: Number,
      default: 0
    },
    isUp: {
      type: Boolean,
      default: false
    },
    downCount: {
      type: Number,
      default: 0
    },
    isDown: {
      type: Boolean,
      default: false
    },
    curriculum: {
      type: Object,
      default: null
    },
    tags: {
      type: Array,
      default: () => []
    },
    link: {
      type: Object,
      default: () => {
        // return {
        //   url: 'https://m.hupu.com/bbs/38985907_36745868040861-1.html',
        //   title: '上交所发布关于暂缓蚂蚁科技集团股份有限公司科创板上市的决定于暂缓蚂蚁科技集团股份有限公司科创板上市的决定',
        //   imgUrl: 'https://i4.hoopchina.com.cn/blogfile/202011/3/BbsImg_103207618181241_1604410681_s_37809_o_w_324_h_720_31734.jpg?x-oss-process=image/resize,w_800/format,jpg'
        // }
        return null
      }
    },
    comment_list: {
      type: Array,
      default: null
    },
    expandProps: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isShow: false, // 控制评论折叠参数
      modelSrc: [],
      showPand: false, // 是否显示展开按钮
      expand: this.expandProps, // 展开
      modelShow: false,
      initialIndex: 0,
      users: get('user'),
      downDisabled: false,
      tagArray: [
        // {
        //   id: 1,
        //   title: 'sss'
        // },
        // {
        //   id: 2,
        //   title: '前方探子来报'
        // },
        // {
        //   id: 3,
        //   title: '前方探子来报，小大董星巴克都已经上线，机场的外卖小哥衣服超好看！还准备了单独的用餐区，希望其他的机场可以迅速跟上！'
        // }
      ],
      scrolNumber: 0,
      isShowIcon: true
    }
  },
  mounted () {
    if (this.post_type === 'video' && this.$route.path.search('/dynamicTetail') === -1) {
      this.scrollToTop()
      window.addEventListener('scroll', this.scrollToTop, true)
    }

    if (this.post_type === 'video' && this.$route.path.search('/dynamicTetail') !== -1) {
      setTimeout(() => {
        this.$refs.video.volume = 0
        this.$refs.video.play()
      }, 500)
    }
    this.judgePand()
  },
  activated () {
    if (this.$route.path.search('/dynamicTetail') !== -1) {
      setTimeout(() => {
        this.$refs.video.volume = 0
        this.$refs.video.play()
      }, 500)
    }
  },
  directives: {
    trigger: {
      inserted (el) {
        // console.log('触发')
        el.click()
      }
    }
  },
  methods: {
    // // 跳转钉钉聊天框逻辑
    goDDconversation () {
      openSingleChat({
        name: this.user.fullname ? this.user.fullname : this.user.nickName,
        userId: this.user.jobCode
      })
    },
    // 切换为大屏播放
    cutSizeScreen () {
      this.$bus.$emit('openBigScreen', this.images[0].url)
    },
    scrollToTop () {
      this.scrolNumber = this.$refs.sortMenu.getBoundingClientRect().top
      if (this.clientHeight - this.scrolNumber > 150 && this.clientHeight - this.scrolNumber < this.clientHeight - 30) {
        this.$bus.$emit('isVideoPlay', this.id, true)
        if (this.videoPlay[0] === this.id) {
          this.isShowIcon = false
          this.$nextTick(() => {
            this.$refs.video.volume = 0
            this.$refs.video.play()
          })
        }
      } else {
        this.$bus.$emit('isVideoPlay', this.id, false)
        if (!this.isShowIcon) {
          this.$nextTick(() => {
            this.$refs.video.pause()
            this.isShowIcon = true
          })
        }
      }
      // scrolNumber 是在data中定义的一个字段
    },
    // 留言列表的折叠展示
    isShowMessage () {
      this.isShow = !this.isShow
    },
    // // 是否显示更多留言
    // isShowRestsMessage () {
    //   this.isShow = !this.isShow
    // },
    IsURL (url) {
      const flag = IsURL(url)
      return flag
    },
    goLink (url) {
      window.location.href = url
    },
    getHttpsImg (url) {
      if (url.indexOf('https') === -1) {
        url = url.replace('http', 'https')
      }
      return url
    },
    deleteMessage () {
      const promise = _delete({
        url: `/circle/circle?id=${this.id}`
      })
      promise.then(res => {
        const { data: { message } } = res
        this.$emit('deleteMessage', this.id)
        Toast.success(message)
      })
    },
    changeModel (index = 0) {
      this.initialIndex = 0
      if (index) {
        this.initialIndex = index
      }
      this.modelShow = !this.modelShow
      if (this.modelShow) {
        this.modelSrc = this.getImages
      }
    },
    getShowTime (time) {
      return getBeforeTimeStr(time)
    },
    goCreate () {
      this.$router.push(`/exerland/create?circleId=${this.id}`)
    },
    goCurriculumDetails (id) {
      this.$router.push(`/exerland/RefiningDetails/${id}`)
    },
    setpOn () {
      const promsie = post({
        url: `/circle/isDown/${this.id}/${get('user').id}`,
        data: {
          isDown: !this.isDown
        }
      })
      promsie.then(res => {
        const { status, data: { detail } } = res
        if (Object.is(status, 200)) {
          this.$emit('updateItem', detail)
        }
      })
    },
    thumbsUp (callback) {
      // console.log(callback)
      const promsie = post({
        url: `/circle/isUp/${this.id}/${get('user').id}`,
        data: {
          isUp: !this.isUp
        }
      })
      promsie.then(res => {
        const { status, data: { detail } } = res
        if (Object.is(status, 200)) {
          if (callback) {
            if (!this.isUp && this.visible_range === 'oversea') {
              messageInform({
                circle_id: this.id,
                action_type: 2,
                mobile: this.user.username,
                operator_mobile: this.users.username,
                is_anonymous: !this.is_actual,
                comment_id: null
              })
            }
            callback()
          }
          this.$emit('updateItem', detail)
        }
      })
    },
    goRedirectDetails (e) {
      if (e.target.className === 'backTop' ||
          e.target.className.indexOf('canvasImg') !== -1 ||
          e.target.className.indexOf('van-overlay') !== -1) {
        return
      }
      const path = this.$route.path
      if (path.indexOf('dynamicTetail') !== -1) {
        return
      }
      // const visibleRange = this.$route.path.indexOf('overseasDetail') !== -1 ? 'oversea' : 'common'
      this.$router.push({
        path: `/exerland/dynamicTetail/${this.id}`
      })
      // this.$router.push(`/exerland/dynamicTetail/${this.id}`)
    },
    goDetails () {
      const path = this.$route.path
      if (path.indexOf('dynamicTetail') !== -1) {
        this.$router.push(`/exerland/create?circleId=${this.id}&visible_range=${this.visible_range}`)
        return
      }
      if (this.commentCount) {
        this.$router.push({
          name: 'Create',
          query: {
            circleId: this.id,
            mobile: this.user.username,
            visible_range: this.visible_range
          }
        })
      } else {
        this.$router.push({
          name: 'Create',
          query: {
            circleId: this.id,
            mobile: this.user.username,
            visible_range: this.visible_range
          }
        })
      }
      this.$emit('click')
    },
    judgePand () {
      const ref = `${this.id}title`
      this.$nextTick(() => {
        const el = this.$refs[`${ref}`]
        this.showPand = isOverflow(el)
        // console.log('数据', el.clientHeight, el.offsetHeight, el.offsetHeight, el.getBoundingClientRect())
      })
    },
    goFilterFind (tag) {
      const currentRoute = this.$router.currentRoute
      if (currentRoute.name === 'FilterFind') {
        this.$router.replace({
          name: 'FilterFind',
          params: {
            id: tag.id,
            title: tag.title
          }
        })
      } else {
        this.$router.push({
          name: 'FilterFind',
          params: {
            id: tag.id,
            title: tag.title
          }
        })
      }
    }
  },
  computed: {
    getErrorName () {
      const name = this.user.fullname ? this.user.fullname : this.user.nickName
      for (let i = 0; i < name.length; i++) {
        const charCode = name.charCodeAt(i)
        if (charCode >= 0x4e00 && charCode <= 0x9fff) {
          return name.charAt(i)
        }
      }
      return name[0]
    },
    getDown () {
      return {
        idProp: this.isDown,
        url: 'https://exerland-bbs.oss-cn-shanghai.aliyuncs.com/step-on-black.svg',
        url1: 'https://exerland-bbs.oss-cn-shanghai.aliyuncs.com/step-on-white.svg',
        count: this.downCount,
        label: ''
      }
    },
    getThumbUp () {
      return {
        isUp: this.isUp,
        url: 'http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/love-block.svg',
        url1: 'http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/love-grey.svg',
        upCount: this.upCount,
        label: ''
      }
    },
    getImages () {
      return this.images.filter(item => item.url)
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .customClass {
  width: 300px;
}
.vid-wrappper{
  position: relative;
  .play-img {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -16px;
    margin-top: -16px;
    width: 32px;
    height: 32px;
  }
}
.content-item {
  width: 100%;
  box-sizing: border-box;
  margin: 6px 0;
  background-color: #fff;
  border-radius: 15px;
  padding: 23px 3.73vw 8px;
  display: flex;
  justify-content: space-between;
  // border-bottom: 1px solid #f5f5f5;
  .avater {
    border-radius: 50%;
    margin-right: 16px;
    width: 36px;
    height: 36px;
  }
  .content-item-body {
    position: relative;
    width: calc(100% - 52px);
    .video{
      transition:all 0.5s ease-in-out;
      object-fit: fill;
      .video_img{
        transition:all 0.5s ease-in-out;
      }
      // object-fit: cover;
    }
    // 此处定义为变量根据data中的数据进行控件的显影
    // video::-webkit-media-controls-enclosure{
    //   display: none
    // }

    h5 {
      font-size: 14px;
      font-family: SFProText-Regular, SFProText;
      font-weight: 400;
      color: rgba(60, 60, 67, 0.6);
      line-height: 13px;
    }
    .content-item-body{
      width: 100%;
    }
    .content-item-body-header {
      display: flex;
      .content-item-body-header-h2 {
        font-size: 16px;
        // font-family: SFProText-Semibold, SFProText;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        line-height: 21px;
        margin-bottom: 1px;
      }
      .tag {
        box-sizing: border-box;
        font-size: 11px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(24, 204, 159, 1);
        line-height: 20px;
        height: 20px;
        background: rgba(236, 253, 249, 1);
        border-radius: 4px;
        box-sizing: border-box;
        display: inline-block;
        padding: 0 12px;
      }
    }
    .desc {
      // display: flex;
      // align-items: left;
      width: 100%;
      box-sizing: border-box;
      margin-bottom: 10px;
      position: relative;
      .descInfo {
        display: inline-block;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 24px;
        height: auto;
        // max-height: 72px;
        // width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        /deep/ .AtSpan {
          margin: 0 5px;
          color: #5b78a3;
        }
      }
      .expand {
        color: #18cc9f;
        white-space: nowrap;
        // display: flex;
        // justify-items: flex-end;
        // position: absolute;
        // bottom: 2px;
        // right: 0;
        padding-left: 2px;
        background: #fff;
        // background:-webkit-linear-gradient(left,transparent,#fff 55%);
        // background:-o-linear-gradient(right,transparent,#fff 55%);
        // background:-moz-linear-gradient(right,transparent,#fff 55%);
        // background:linear-gradient(to right,transparent,#fff 55%);
      }
      .retract {
        bottom: -20px;
        left: 0;
      }
    }
    .content-item-pdf{
      width: 90vw;
      position: relative;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 5px; /* 可根据需要调整间距 */
      left: -50px;
    }
    .content-item-imgs {
      img {
        max-width: 90px;
        max-height: 90px;
        margin-right: 4px;
      }
      .maxImg {
        max-width: 196px;
        max-height: 196px;
      }
      .singal {
        max-width: 90px;
        max-height: 90px;
      }
      .singal:nth-child(3n) {
        margin-right: 0;
      }
      .square:nth-child(2n) {
        margin-right: 30%;
      }
    }
    .curriculum {
      width: 100%;
      box-sizing: border-box;
      // height:92px;
      background: rgba(245, 245, 245, 1);
      border-radius: 5px;
      padding: 12px 13px;
      display: flex;
      img {
        width: 40.67%;
        height: calc(9 / 16 * 40.67%);
        margin-right: 10px;
      }
      div {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .curriculum-title {
          font-size: 13px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          line-height: 18px;
        }
        .studentCount {
          font-size: 9px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(136, 136, 136, 1);
          line-height: 13px;
        }
      }
    }
    .link-box {
      display: flex;
      align-items: center;
      padding: 5px 6px;
      box-sizing: border-box;
      width: 100%;
      height: 50px;
      background: #f5f5f5;
      border-radius: 5px;
      margin: 12px 0;
      img {
        width: 40px;
        height: 40px;
        display: inline-block;
        margin-right: 5px;
      }
      span {
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        width: calc(100% - 57px);
      }
    }
    .content-bottom {
      display: flex;
      height: 44px;
      justify-content: space-between;
      align-items: center;
      .content-bottom-left {
        display: flex;
        .delete {
          display: block;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(87, 107, 148, 1);
          line-height: 13px;
          margin-left: 16px;
        }
      }
      .menus {
        display: flex;
        justify-content: flex-start;
      }
    }
  }
}
.message-division {
    border-bottom: 1px solid #eeebeb;
}
.tab-box {
  margin-top: 12px;
  .tag-item {
    display: inline-flex;
    // justify-content: space-between;
    align-items: center;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #576b94;
    background: #fff;
    border-radius: 4px;
    margin-right: 12px;
    border-radius: 16px;
    border: 1px solid #e5e5e5;
    padding: 2px 8px;
    box-sizing: border-box;
    margin-bottom: 8px;
    .tag-desc {
      display: inline-block;
      white-space: nowrap;
      max-width: 140px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    img {
      width: 10px;
      height: 10px;
      display: inline-block;
      margin-left: 8px;
    }
  }
}
</style>
